const {store, AoflElement, clickTrackerMixin} = aofljs;
/**
 * @summary HomeHeader
 * @class HomeHeader
 * @extends {AoflElement}
 */
class HomeHeader extends clickTrackerMixin(AoflElement) {
  /**
   * Creates an instance of HomeHeader.
   * Sets isPc property based on store value.
   *
   * @memberof HomeHeader
   */
  constructor() {
    super(store);
    let state = store.getState().userSession;
    this.isPc = !state.isMac;
    this.isApp = state.isApp;
    if (this.isApp) {
      this.isAppStyle = 'is-app';
    }
  }
  /**
   *
   * @readonly
   * @static
   * @memberof HomeHeader
   */
  static get is() {
    return 'home-header';
  }
  /**
   * Shows create shortcut popup based on whether or not device is PC.
   *
   * @param {*} e
   * @memberof HomeHeader
   */
  showCreateShortcutPopup(e) {
    e.preventDefault();
    let modalName = this.isPc ? 'createShortcutPc' : 'createShortcutMac';
    store.commit([
      {
        stateAlias: 'modals',
        mutationId: 'showModal',
        payload: modalName
      }
    ]);
  }
}

window.customElements.define(HomeHeader.is, HomeHeader);



// WEBPACK FOOTER //
// ./home/en-US/js/home-header/home-header.js